import React, { useEffect, useState } from "react";
import {
  useGetUserWalletList,
  useGetUserWalletBalance,
} from "utils/api/admin.api";
import { type UserWalletDetailsProps } from "utils/types/wallet.type";
import WalletList from "./WalletList";
import WalletBalance from "./WalletBalance";

export default function UserWalletDetails({ userId }: UserWalletDetailsProps) {
  const [selectedWalletId, setSelectedWalletId] = useState<string | null>(null);

  const { data: walletList, isLoading: walletListLoading } =
    useGetUserWalletList(userId);

  const { data: walletBalance, isLoading: balanceLoading } =
    useGetUserWalletBalance(userId, selectedWalletId);

  useEffect(() => {
    // Auto-select first wallet if available
    if (walletList?.data && walletList.data.length > 0 && !selectedWalletId) {
      setSelectedWalletId(walletList.data[0]._id);
    }
  }, [walletList, selectedWalletId]);

  const balanceData = walletBalance?.data?.[0];

  return (
    <div
      className="bg-gray-50 border-t border-gray-200 p-6"
      onClick={(e) => e.stopPropagation()}
    >
      <WalletList
        wallets={walletList?.data ?? []}
        isLoading={walletListLoading}
        selectedWalletId={selectedWalletId}
        onWalletSelect={setSelectedWalletId}
      />

      {selectedWalletId && (
        <WalletBalance
          balanceData={balanceData}
          isLoading={balanceLoading}
        />
      )}
    </div>
  );
}
